/**
 * Lightweight CRC-32 (ISO 3309 / ITU-T V.42) implementation.
 *
 * No dependencies.  Works on Uint8Array input and returns an unsigned
 * 32-bit integer.  The hex helper returns the conventional lowercase
 * zero-padded 8-char hex string.
 */

// Pre-computed CRC-32 lookup table (polynomial 0xEDB88320)
const TABLE = new Uint32Array(256);
for (let i = 0; i < 256; i++) {
  let crc = i;
  for (let j = 0; j < 8; j++) {
    crc = crc & 1 ? (crc >>> 1) ^ 0xedb88320 : crc >>> 1;
  }
  TABLE[i] = crc;
}

/**
 * Compute CRC-32 of a Uint8Array.
 * @param {Uint8Array} data
 * @returns {number} unsigned 32-bit CRC value
 */
export function crc32(data) {
  let crc = 0xffffffff;
  for (let i = 0; i < data.length; i++) {
    crc = (crc >>> 8) ^ TABLE[(crc ^ data[i]) & 0xff];
  }
  return (crc ^ 0xffffffff) >>> 0;
}

/**
 * Return CRC-32 as an 8-character lowercase hex string.
 * @param {Uint8Array} data
 * @returns {string}
 */
export function crc32hex(data) {
  return crc32(data).toString(16).padStart(8, '0');
}
